/**
 * 获取本周、本季度、本月、上月...的开始日期、结束日期
 */
var now = new Date(); //当前日期
var nowDay = now.getDate(); //当前日
var nowDayOfWeek = now.getDay(); //今天本周的第几天
var nowMonth = now.getMonth(); //当前月
var nowYear = now.getYear(); //当前年
nowYear += nowYear < 2000 ? 1900 : 0; //
var lastMonthDate = new Date(); //上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
//去年
var lastYear = lastMonthDate.getYear();
//上月
var lastMonth = lastMonthDate.getMonth();
//今天
var today = formatDate(now);
//昨天
var yesterday = formatDate(new Date(now.getTime() - 24 * 60 * 60 * 1000));

//格式化日期：yyyy-MM-dd
function formatDate(date) {
  var myyear = date.getFullYear();
  var mymonth = date.getMonth() + 1;
  var myweekday = date.getDate();
  if (mymonth < 10) {
    mymonth = '0' + mymonth;
  }
  if (myweekday < 10) {
    myweekday = '0' + myweekday;
  }
  return myyear + '-' + mymonth + '-' + myweekday;
}

function getRangeStartDate(n) {
  var rangeStartDate = new Date(now.getTime() - 24 * 60 * 60 * 1000 * Number(n || 0));
  return formatDate(rangeStartDate);
}

//获得本周的开始日期
function getWeekStartDate() {
  var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
  return formatDate(weekStartDate);
}
//获得本周的结束日期
function getWeekEndDate() {
  var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
  return formatDate(weekEndDate);
}
//获得上周的开始日期
function getLastWeekStartDate() {
  var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 7);
  return formatDate(weekStartDate);
}
//获得上周的结束日期
function getLastWeekEndDate() {
  var weekEndDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 1);
  return formatDate(weekEndDate);
}

//获得某月的天数
function getMonthDays(myMonth) {
  var monthStartDate = new Date(nowYear, myMonth, 1);
  var monthEndDate = new Date(nowYear, myMonth + 1, 1);
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
}
//获得本月的开始日期
function getMonthStartDate() {
  var monthStartDate = new Date(nowYear, nowMonth, 1);
  return formatDate(monthStartDate);
}
//获得本月的结束日期
function getMonthEndDate() {
  var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
  return formatDate(monthEndDate);
}
//获得上月开始时间
function getLastMonthStartDate() {
  var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
  return formatDate(lastMonthStartDate);
}
//获得上月结束时间
function getLastMonthEndDate() {
  var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
  return formatDate(lastMonthEndDate);
}

//获得本季度的开始月份
function getQuarterStartMonth() {
  var quarterStartMonth = 0;
  if (nowMonth < 3) {
    quarterStartMonth = 0;
  }
  if (2 < nowMonth && nowMonth < 6) {
    quarterStartMonth = 3;
  }
  if (5 < nowMonth && nowMonth < 9) {
    quarterStartMonth = 6;
  }
  if (nowMonth > 8) {
    quarterStartMonth = 9;
  }
  return quarterStartMonth;
}
//获得本季度的开始日期
function getQuarterStartDate() {
  var quarterStartDate = new Date(nowYear, getQuarterStartMonth(), 1);
  return formatDate(quarterStartDate);
}
//或的本季度的结束日期
function getQuarterEndDate() {
  var quarterEndMonth = getQuarterStartMonth() + 2;
  var quarterEndDate = new Date(nowYear, quarterEndMonth, getMonthDays(quarterEndMonth));
  return formatDate(quarterEndDate);
}

//获得上季度的开始月份
function getLastQuarterStartMonth() {
  var lastQuarterStartMonth = 0;
  if (nowMonth < 3) {
    lastQuarterStartMonth = 9;
  }
  if (2 < nowMonth && nowMonth < 6) {
    lastQuarterStartMonth = 0;
  }
  if (5 < nowMonth && nowMonth < 9) {
    lastQuarterStartMonth = 3;
  }
  if (nowMonth > 8) {
    lastQuarterStartMonth = 6;
  }
  return lastQuarterStartMonth;
}
//获得上季度的开始日期
function getLastQuarterStartDate() {
  if (getLastQuarterStartMonth() == 9) {
    var lastQuarterStartDate = new Date(lastYear, getLastQuarterStartMonth(), 1);
  } else {
    var lastQuarterStartDate = new Date(nowYear, getLastQuarterStartMonth(), 1);
  }
  return formatDate(lastQuarterStartDate);
}
//或的本上季度的结束日期
function getLastQuarterEndDate() {
  var lastQuarterEndMonth = getLastQuarterStartMonth() + 2;
  if (getLastQuarterStartMonth() == 9) {
    var lastQuarterEndDate = new Date(
      lastYear,
      lastQuarterEndMonth,
      getMonthDays(lastQuarterEndMonth)
    );
  } else {
    var lastQuarterEndDate = new Date(
      nowYear,
      lastQuarterEndMonth,
      getMonthDays(lastQuarterEndMonth)
    );
  }
  return formatDate(lastQuarterEndDate);
}

var date = {
  dateRange: function(filterDate) {
    switch (filterDate.type) {
      case '': // 没值
        return {
          startDate: '',
          endDate: ''
        };
      case 'all': //所有
        return {
          startDate: '',
          endDate: ''
        };
      case 'custom': //
        return {
          startDate: filterDate.range && filterDate.range[0],
          endDate: filterDate.range && filterDate.range[1]
        };
      case 'today': //今天
        return {
          startDate: today,
          endDate: today
        };
      case 'yesterday': //昨天
        return {
          startDate: yesterday,
          endDate: yesterday
        };

      case 'thisWeek': //本周
        return {
          startDate: getWeekStartDate(),
          endDate: getWeekEndDate()
        };
      case 'lastWeek': //上周
        return {
          startDate: getLastWeekStartDate(),
          endDate: getLastWeekEndDate()
        };
      case 'thisMonth': //本月
        return {
          startDate: getMonthStartDate(),
          endDate: getMonthEndDate()
        };
      case 'lastMonth': //上月
        return {
          startDate: getLastMonthStartDate(),
          endDate: getLastMonthEndDate()
        };
      case 'thisQuarter': //本季度
        return {
          startDate: getQuarterStartDate(),
          endDate: getQuarterEndDate()
        };
      case 'lastQuarter': //上季度
        return {
          startDate: getLastQuarterStartDate(),
          endDate: getLastQuarterEndDate()
        };
      case 'thisYear': //今年
        return {
          startDate: nowYear + '-1-1',
          endDate: nowYear + '-12-31'
        };
      case 'lastYear': //去年
        return {
          startDate: lastYear + '-1-1',
          endDate: lastYear + '-12-31'
        };
      default:
        //最近 7 14 30 60 90 365 天
        if (Number(filterDate.type) || Number(filterDate.type) == 0) {
          return {
            startDate: getRangeStartDate(filterDate.type),
            endDate: yesterday
          };
        }
    }
  },
  pickerOptions: {
    shortcuts: [
      {
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', [today + ' 00:00:00', today + ' 23:59:59']);
        }
      },
      {
        text: '本周',
        onClick(picker) {
          picker.$emit('pick', [getWeekStartDate() + ' 00:00:00', getWeekEndDate() + ' 23:59:59']);
        }
      },
      {
        text: '本月',
        onClick(picker) {
          picker.$emit('pick', [
            getMonthStartDate() + ' 00:00:00',
            getMonthEndDate() + ' 23:59:59'
          ]);
        }
      },
      {
        text: '本季度',
        onClick(picker) {
          picker.$emit('pick', [
            getQuarterStartDate() + ' 00:00:00',
            getQuarterEndDate() + ' 23:59:59'
          ]);
        }
      },
      {
        text: '今年',
        onClick(picker) {
          picker.$emit('pick', [nowYear + '-01-01 00:00:00', nowYear + '-12-31 23:59:59']);
        }
      },
      {
        text: '最近一周',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [
            window.$this.$util.readableTime(start),
            window.$this.$util.readableTime(end)
          ]);
        }
      },
      {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [
            window.$this.$util.readableTime(start),
            window.$this.$util.readableTime(end)
          ]);
        }
      },
      {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [
            window.$this.$util.readableTime(start),
            window.$this.$util.readableTime(end)
          ]);
        }
      }
    ]
  },
  /**
   * 计算时间差
   * @param {*} ms 时间差毫秒值
   * @param {*} type type:'m' 只精确到分钟
   * @returns
   */
  count(ms, type) {
    ms = ms ? new Date(Math.abs(ms)).getTime() : new Date().getTime();
    // toFixed解决科学计数问题
    let years = parseInt((ms / (365 * 24 * 60 * 60 * 1000)).toFixed(2));
    let months = parseInt(
      ((ms % (365 * 24 * 60 * 60 * 1000)) / (30 * 24 * 60 * 60 * 1000)).toFixed(2)
    );
    let days = parseInt(((ms % (30 * 24 * 60 * 60 * 1000)) / (24 * 60 * 60 * 1000)).toFixed(2));
    let hours = parseInt(((ms % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)).toFixed(2));
    let minutes = parseInt(((ms % (60 * 60 * 1000)) / (60 * 1000)).toFixed(2));
    let seconds = parseInt(((ms % (60 * 1000)) / 1000).toFixed(2));
    let str =
      (years ? years + '年' : '') +
      (months ? months + '个月' : '') +
      (days ? days + '天' : '') +
      (hours ? hours + '小时' : '') +
      (minutes ? minutes + '分钟' : '') +
      (seconds && type != 'm' ? seconds + '秒' : '');
    return str;
  }
};

export default { date };
